
export default function Noticias() {
  return (
    <section id="noticias" className="py-32 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="flex justify-between items-end mb-16">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Últimas Noticias y Eventos
            </h2>
            <p className="text-gray-500 mt-3 text-lg">Síguenos en Facebook para estar al día con todo lo que publicamos</p>
          </div>
          <a
            href="https://www.facebook.com/CDESULA?mibextid=rS40aB7S9Ucbxw6v"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="hidden md:flex items-center space-x-2 px-6 py-3 bg-[#1877F2] text-white rounded-lg font-semibold hover:bg-[#1565D8] transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-facebook-fill text-lg"></i>
            <span>Ver Página de Facebook</span>
          </a>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 items-start justify-center">
          {/* Feed principal de Facebook */}
          <div className="flex-1 flex justify-center">
            <div className="bg-white rounded-2xl shadow-md overflow-hidden w-full max-w-[500px]">
              <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCDESULA&tabs=timeline&width=500&height=700&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                width="500"
                height="700"
                style={{ border: 'none', overflow: 'hidden', width: '100%' }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                title="Facebook Page Feed CDESULA"
              ></iframe>
            </div>
          </div>

          {/* Panel lateral: info + botones */}
          <div className="lg:w-80 flex flex-col gap-6">
            <div className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#1877F2] rounded-full mb-4">
                <i className="ri-facebook-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-1">CDE SULA</h3>
              <p className="text-gray-500 text-sm mb-4">Centro de Desarrollo Empresarial del Valle de Sula</p>
              <a
                href="https://www.facebook.com/CDESULA?mibextid=rS40aB7S9Ucbxw6v"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-full flex items-center justify-center space-x-2 px-5 py-3 bg-[#1877F2] text-white rounded-lg font-semibold hover:bg-[#1565D8] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-facebook-fill"></i>
                <span>Seguir en Facebook</span>
              </a>
            </div>

            <div className="bg-white rounded-2xl shadow-md p-6">
              <h4 className="font-bold text-gray-900 mb-4 text-base">También encuéntranos en:</h4>
              <div className="flex flex-col gap-3">
                <a
                  href="https://www.instagram.com/cdemipymervs?igsh=MXQ1eWlucnhkaHNocg%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center space-x-3 px-4 py-3 bg-gradient-to-r from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] text-white rounded-lg font-semibold hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-instagram-line text-lg"></i>
                  <span>Instagram</span>
                </a>
                <a
                  href="https://youtube.com/@cdemipymervs?si=zkjL8PZGuYKflsWa"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center space-x-3 px-4 py-3 bg-[#FF0000] text-white rounded-lg font-semibold hover:bg-[#CC0000] transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-youtube-line text-lg"></i>
                  <span>YouTube</span>
                </a>
                <a
                  href="https://whatsapp.com/channel/0029Vb6BHBp4IBh5TykghK06"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center space-x-3 px-4 py-3 bg-[#25D366] text-white rounded-lg font-semibold hover:bg-[#1EB855] transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                  <span>WhatsApp</span>
                </a>
              </div>
            </div>

            <div className="bg-[#1877F2]/5 border border-[#1877F2]/20 rounded-2xl p-5 text-sm text-gray-600 leading-relaxed">
              <i className="ri-information-line text-[#1877F2] mr-2"></i>
              El feed se actualiza en tiempo real con las publicaciones más recientes de nuestra página oficial de Facebook.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
